module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#star",
      toString: function () {
        return this.url;
      }
    }